import axios from 'axios'
const state = () => ({
    carousel: []
})

const getters = {
    carousel(state) {
        return state.carousel
    }
}

const mutations = {
    GET_CAROUSEL(state, payload){
        state.carousel = payload
    },
}

const actions = {
    getCarousel({commit}){
        axios.get(`https://api.geomalaka.uz/api/main/carusel/`)
            .then((res)=>{
                commit("GET_CAROUSEL", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
